module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a-plane', {
    attrs: {
      "width": _vm.tweetParams.width,
      "height": _vm.tweetParams.height,
      "position": _vm.attributify(_vm.position),
      "material": "opacity: 0;",
      "look-at": "#camera"
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7dd4a10a!./~/vue-loader/lib/selector.js?type=template&index=0!./client/components/Tweet.vue
// module id = 184
// module chunks = 2